import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { ReactComponent as SiriusXMLogo } from '../../assets/images/sxm-logo-blue.svg';
import { storageManager } from '../../config/storage-manager';
import { appRouteConstants } from '../../routing/app.route.constants';
import { StorageKeyConstant } from '../../servicelib';
import './login-page.component.scss';

export const LoginConfirmationPageComponent = ({ setScanForBypass }) => {
  const history = useHistory();
  const readyForListen = storageManager.cloudCookieManager.get(
    StorageKeyConstant.READY_TO_LISTEN,
  );
  const readyForListenTitle = storageManager.cloudCookieManager.get(
    StorageKeyConstant.READY_TO_LISTEN_TITLE,
  );

  useEffect(() => {
    of(appRouteConstants.HOME_FORYOU)
      .pipe(delay(5000))
      .subscribe(route => {
        history.replace(route);
        setScanForBypass(true);
      });
  }, []);

  return (
    <div className="login-confirmation-page">
      <div className="login-confirmation-logo-container">
        <div>
          <SiriusXMLogo />
        </div>
      </div>
      <div className="login-confirmation-content-container">
        <div className="login-confirmation-text-container">
          <span className="title">{readyForListenTitle}</span>
          <span className="subtitle">{readyForListen}</span>
        </div>
      </div>
    </div>
  );
};
